<template>
  <div
    id="apps_page"
    class="card"
  >
    <b-card-header v-if="$hasPermission('create_apps')">
      <b-button
        v-b-modal.modal-add-new-app
        variant="success"
      >
        {{ $t('apps.addNew') }}
      </b-button>
      <!--      <b-button variant="primary" @click.prevent="search()"
            >Search
            </b-button>-->
    </b-card-header>
    <div class="table-responsive mb-0">
      <table
        role="table"
        :aria-busy="isBusy"
        class="table b-table table-striped table-hover"
      >
        <thead
          role="rowgroup"
          class=""
        >
          <tr
            role="row"
            class=""
          >
            <th
              role="columnheader"
              aria-colindex="1"
              :aria-sort="arialSort('app_name')"
              style="cursor: pointer;"
              @click="sortCol('app_name')"
            >
              {{ $t('apps.appName') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="2"
            >
              {{ $t('apps.status') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="2"
              :aria-sort="arialSort('active_users')"
              style="cursor: pointer;"
              @click="sortCol('active_users')"
            >
              {{ $t('apps.30DaysActiveUsers') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('monetized_users')"
              style="cursor: pointer;"
              @click="sortCol('monetized_users')"
            >
              {{ $t('apps.30DaysMonetizedUsers') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('publisher_revenue')"
              style="cursor: pointer;"
              @click="sortCol('publisher_revenue')"
            >
              {{ $t('apps.30DaysRevenue') }}
            </th>
            <th
              v-if="$hasPermission('view_app_details')"
              style="width: 13.571rem"
            >
              {{ $t('apps.action') }}
            </th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          <template v-for="(rowTr, indextr) in sortedItems">
            <tr :key="indextr">
              <td>
                <div class="d-flex align-items-center">
                  <app-link :app="rowTr" />
                </div>
              </td>
              <td>
                <b-badge
                  pill
                  :variant="'light-' + rowTr.status_color"
                >
                  {{ systemLabel(rowTr.status_text) }}
                </b-badge>
              </td>
              <td>{{ rowTr.active_users | formatCount }}</td>
              <td>{{ rowTr.monetized_users | formatCount }}</td>
              <td>
                {{
                  rowTr.publisher_revenue | formatCurrency
                }}
              </td>
              <td v-if="$hasPermission('view_app_details')">
                <b-button
                  size="sm"
                  variant="primary"
                  @click.prevent.stop="editData(rowTr)"
                >{{ $t('apps.edit') }}
                </b-button>
              <!--              <b-button
                                size="sm"
                                variant="danger"
                                @click.prevent.stop="deleteData(rowTr.hash)"
                            >Delete
                            </b-button>-->
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <b-card-footer>
      <b-row>
        <b-col
          v-show="items && items.length > 0"
          cols="12"
        >
          <pagination-and-table-info
            :data="paginationData"
            @change="handleChangePage($event)"
          />
        </b-col>
        <b-col
          v-show="items && items.length === 0"
          cols="12"
          style="font-weight: 500; text-align: center"
        >
          {{ $t('apps.noData') }}
        </b-col>
      </b-row>
    </b-card-footer>
    <b-modal
      id="modal-add-new-app"
      scrollable
      hide-footer
      hide-header
      size="md"
    >
      <add-new-app
        :data="sidebarData"
        @added_app="added_app"
      />
    </b-modal>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'
import { systemLabel } from '@/libs/i18n/display'

import PaginationAndTableInfo from '@ps_main/custom-components/PaginationAndTableInfo.vue'
import AddNewApp from '@/views/apps/AddNewApp.vue'
import AppLink from '@/main/custom-components/AppLink.vue'

export default {
  components: {
    AppLink,
    AddNewApp,
    PaginationAndTableInfo,
  },
  data() {
    return {
      isBusy: false,
      params: {
        page: 1,
        item_per_page: 500,
      },
      sortBy: 'publisher_revenue',
      sortDirection: 'desc',
      filters: {
        variables: {},
        init_filter: 0,
      },
      items: [],
      responseData: null,
      addNewDataSidebar: false,
      sidebarData: {},
    }
  },
  computed: {
    paginationData() {
      return this.laravelPaginationPages(this.responseData)
    },
    sortedItems() {
      if (!this.items || this.items.length === 0) {
        return []
      }

      const sorted = [...this.items].sort((a, b) => {
        let aValue = a[this.sortBy]
        let bValue = b[this.sortBy]

        // Handle numeric values
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return this.sortDirection === 'asc' ? aValue - bValue : bValue - aValue
        }

        // Handle string values
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          aValue = aValue.toLowerCase()
          bValue = bValue.toLowerCase()
          if (this.sortDirection === 'asc') {
            return aValue.localeCompare(bValue)
          }
          return bValue.localeCompare(aValue)
        }

        // Handle null/undefined values
        if (aValue === null || aValue === undefined) aValue = ''
        if (bValue === null || bValue === undefined) bValue = ''

        return this.sortDirection === 'asc'
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue))
      })

      return sorted
    },
  },
  created() {
    this.search()
  },
  methods: {
    systemLabel,
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    async deleteData(appHash) {
      const result = await this.confirm(i18n.t('apps.areYouSure'))
      if (result) {
        this.processDelete(appHash)
      }
    },
    processDelete(appHash) {
      this.showLoading()
      this.$http.delete(`/api/apps/delete/${appHash}`).then(response => {
        this.search()
        this.alertSuccess(response.data.message)
      }).catch(errors => {
        this.alertApiError(errors, i18n.t('apps.appDeleteFailed'))
        this.hideLoading()
      })
    },
    editData(data) {
      this.$router.push({
        name: 'app-edit',
        params: {
          appHash: data.hash,
        },
      }).catch()
    },
    handleChangePage(page) {
      this.params.page = page
      this.search()
    },
    sortCol(fieldName) {
      if (this.sortBy === fieldName) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortBy = fieldName
        this.sortDirection = 'asc'
      }
    },
    arialSort(sortFieldName) {
      if (this.sortBy === sortFieldName) {
        return this.sortDirection === 'asc'
          ? 'ascending'
          : 'descending'
      }
      return 'none'
    },
    search() {
      this.isBusy = true
      this.showLoading()
      this.$http.get('/api/apps', {
        params: {
          ...this.params,
          ...this.filters.variables,
        },
      }).then(response => {
        this.items = response.data.data
        this.responseData = response.data
        this.isBusy = false
      }).catch(errors => {
        this.items = []
        this.responseData = null
        this.alertApiError(errors, i18n.t('apps.appsRequestFailed'))
        this.isBusy = false
      }).finally(() => {
        this.hideLoading()
      })
    },
    added_app(data) {
      this.alertSuccess(data.message)
      const newItem = data.app

      // Prepend to table items
      this.items = [newItem, ...((Array.isArray(this.items) ? this.items : []))]

      // If pagination data exists, update its data array and total count
      if (this.responseData && Array.isArray(this.responseData.data)) {
        this.responseData.data = [newItem, ...((Array.isArray(this.responseData.data) ? this.responseData.data : []))]
        this.responseData.total = (this.responseData.total || 0) + 1
      }

      // Ensure we show the first page after adding
      this.params.page = 1
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },
  },
}
</script>
